module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/314.5f6cb7e8.png";